import styled from 'styled-components';

const Container = styled.p`
  text-align: center;
`;

export default Container;
